import React, { useState } from 'react';
import axios from 'axios';

const HostRegistration = () => {
    const [formData, setFormData] = useState({
        Email: '',
        Password: '',
        Hostname: '',
        Contact: '',
        platformId: '',
        IsApproved: 0
    });
    const platformId = localStorage.getItem('platformID')

    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const API = process.env.REACT_APP_API_BASE_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!platformId) {
            alert("Select platform.")
            return;
        }
        setFormData({ ...formData, platformId: platformId });
        setMessage('');
        setError('');

        try {
            const response = await axios.post(`${API}/api/host/register`, formData);
            setMessage(response.data.message);
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred');
        }
    };

    return (
        <div className="container my-3">

            <div className="col-md-12">


                <h2>Host Registration</h2>


                <form onSubmit={handleSubmit}>

                    <div className="mb-3" class="col-md-6">
                        <label className="form-label">Email:</label>
                        <input
                            type="email"
                            name="Email"
                            className="form-control"
                            value={formData.Email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="mb-3" class="col-md-6">
                        <label className="form-label">Password:</label>
                        <input
                            type="password"
                            name="Password"
                            className="form-control"
                            value={formData.Password}
                            onChange={handleChange}
                            required
                        />
                    </div>


                    <div className="mb-3" class="col-md-6">
                        <label className="form-label">Hostname:</label>
                        <input
                            type="text"
                            name="Hostname"
                            className="form-control"
                            value={formData.Hostname}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-3" class="col-md-6">
                        <label className="form-label">Contact:</label>
                        <input
                            type="text"
                            name="Contact"
                            className="form-control"
                            value={formData.Contact}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div class="row mt-3">
                        <div className="mb-3" class="col-md-6">
                            <button type="submit" className="btn btn-primary">
                                Register
                            </button>
                        </div>
                    </div>
                </form>
                {message && <p className="mt-3 text-success text-center">{message}</p>}
                {error && <p className="mt-3 text-danger text-center">{error}</p>}
            </div>
        </div>



    );
};

export default HostRegistration;